import { Command } from "@alchemy/ui";

import useTeamSupportUrl from "../../react-query/queries/useTeamSupportUrl";

const SupportFAB = () => {
  const teamSupport = useTeamSupportUrl();

  return (
    <>
      {/* A placeholder element to prevent FAB from going over website elements without an option to scroll over it */}
      <div className="h-16" />

      <Command
        as="a"
        target="_blank"
        rel="noreferrer noopener"
        href={teamSupport.data?.url}
        background="dark"
        className="fixed bottom-5 right-5 z-10 flex h-10 w-24 items-center justify-center rounded-full bg-grayscale-950 text-paragraph-100-medium text-white"
      >
        Get Support
      </Command>
    </>
  );
};

export default SupportFAB;
